import { useEffect, useState } from 'react';
import LanguageContext from './language.context';

function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('pt');

  useEffect(() => {
    document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'en';
  }, [language]);

  return (
    <LanguageContext.Provider value={ { language, setLanguage } }>
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageProvider;
